import { OddsTypeIndicator } from '@library/components/OddsTypeIndicator';
import { isAdjustedOdds } from '@library/utils';

export interface LineAnalysis {
  // playerId: string;
  sportRadarId: string;
  playerName: string;
  position?: string;
  normalizedPlayerName: string;
  team: string;
  stat: string;
  lineType: 'Median' | 'Alt';
  line: string;
  fanduel: string;
  draftkings: string;
  underdog: string;
  pinnacle: string;
  bet365: string;
  betMGM: string;
  circa: string;
  currentlyPosted: string;
  market: string;
  deviggedAmericanOdds: string;
  impliedProb: string;
}

export interface LineAnalyzerRowProps {
  lineAnalysis: LineAnalysis;
}

export const LineAnalyzerRow = ({ lineAnalysis }: LineAnalyzerRowProps) => {
  const {
    //  playerId,
    sportRadarId,
    playerName,
    position = '',
    stat,
    line,
    fanduel,
    draftkings,
    underdog,
    pinnacle,
    bet365,
    betMGM,
    circa,
    currentlyPosted,
    deviggedAmericanOdds,
    impliedProb
  } = lineAnalysis;
  const lineType = isAdjustedOdds(Number(impliedProb)) ? 'Alt' : 'Median';
  const isDemon = Number(impliedProb) <= 0.47;

  return (
    <div className="border-soFresh-140 text-soClean-110 hover:bg-soFresh-120 text-2xs flex border-b py-3 xl:text-xs">
      {/* <div className="flex w-40 items-center pl-3">
        <span>{playerId}</span>
      </div> */}
      <div className="flex w-40 items-center text-wrap break-all pl-3">
        <span className="text-2xs">{sportRadarId}</span>
      </div>
      <div className="flex w-36 items-center pl-3">
        <div className="flex flex-col leading-3">
          <span className="text-soClean-100 text-xs">{playerName}</span>
          <span className="text-soClean-170 text-xs">{position}</span>
        </div>
      </div>
      <div className="flex w-80 items-center overflow-x-auto overscroll-x-none pl-3">
        <span>{stat}</span>
      </div>
      <div className="flex w-24 items-center pl-4">
        <span>{lineType}</span>
        {lineType === 'Alt' && (
          <OddsTypeIndicator
            className="ml-2 size-4"
            oddsType={isDemon ? 'demon' : 'goblin'}
          />
        )}
      </div>
      <div className="flex w-24 items-center pl-3">
        <div className="flex flex-col leading-3">
          <span className="text-soClean-100 text-xs">{line}</span>
          <span className="text-soClean-170">{`${deviggedAmericanOdds} (over)`}</span>
        </div>
      </div>
      <div className="flex w-20 items-center pl-3">
        <span>{fanduel}</span>
      </div>
      <div className="flex w-20 items-center pl-3">
        <span>{draftkings}</span>
      </div>
      <div className="flex w-20 items-center pl-3">
        <span>{underdog}</span>
      </div>
      <div className="flex w-20 items-center pl-3">
        <span>{pinnacle}</span>
      </div>
      <div className="flex w-20 items-center pl-3">
        <span>{bet365}</span>
      </div>
      <div className="flex w-20 items-center pl-3">
        <span>{betMGM}</span>
      </div>
      <div className="flex w-20 items-center pl-3">
        <span>{circa}</span>
      </div>
      <div className="flex w-20 items-center pl-3">
        <span>{currentlyPosted}</span>
      </div>
    </div>
  );
};
